module.exports = __webpack_public_path__ + "static/assets/9c2e76fead9ea1b2ca1ee5418779b4a9.svg";